import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/events`;

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

export const getEventCastBundle = async (eventId) => {
  const response = await axios.get(
    `${apiUrl}/${eventId}/cast`,
    authHeaders()
  );

  return response.data;
};

export const getEventCastMessages = async (eventId) => {
  const response = await axios.get(
    `${apiUrl}/${eventId}/cast/messages`,
    authHeaders()
  );

  return response.data;
};

export const initializeEventMats = async (
  eventId,
  count
) => {
  const response = await axios.post(
    `${apiUrl}/${eventId}/cast/mats/initialize`,
    {
      count: Number(count),
    },
    authHeaders()
  );

  return response.data;
};

export const addEventMat = async (
  eventId,
  payload = {}
) => {
  const response = await axios.post(
    `${apiUrl}/${eventId}/cast/mats/add`,
    {
      surface_type:
        payload.surface_type || "MAT",

      label:
        payload.label !== undefined
          ? payload.label
          : null,

      is_open:
        payload.is_open !== undefined
          ? Boolean(payload.is_open)
          : true,
    },
    authHeaders()
  );

  return response.data;
};

export const upsertEventMatWithSlots = async (
  eventId,
  matNumber,
  payload
) => {
  const response = await axios.put(
    `${apiUrl}/${eventId}/cast/mats/${matNumber}`,
    payload,
    authHeaders()
  );

  return response.data;
};

export const toggleEventMatOpen = async (
  eventId,
  matNumber
) => {
  const response = await axios.put(
    `${apiUrl}/${eventId}/cast/mats/${matNumber}/toggle`,
    {},
    authHeaders()
  );

  return response.data;
};

export const deleteEventMat = async (
  eventId,
  matNumber
) => {
  const response = await axios.delete(
    `${apiUrl}/${eventId}/cast/mats/${matNumber}`,
    authHeaders()
  );

  return response.data;
};

export const upsertEventCastState = async (
  eventId,
  payload
) => {
  const response = await axios.put(
    `${apiUrl}/${eventId}/cast/state`,
    payload,
    authHeaders()
  );

  return response.data;
};

export const createEventCastMessage = async (
  eventId,
  payload
) => {
  const response = await axios.post(
    `${apiUrl}/${eventId}/cast/messages/add`,
    payload,
    authHeaders()
  );

  return response.data;
};

export const updateEventCastMessage = async (
  eventId,
  message
) => {
  const response = await axios.put(
    `${apiUrl}/${eventId}/cast/messages/update/${message.id}`,
    message,
    authHeaders()
  );

  return response.data;
};

export const toggleEventCastMessageActive = async (
  eventId,
  messageId
) => {
  const response = await axios.put(
    `${apiUrl}/${eventId}/cast/messages/toggle/${messageId}`,
    {},
    authHeaders()
  );

  return response.data;
};

export const deleteEventCastMessage = async (
  eventId,
  messageId
) => {
  const response = await axios.delete(
    `${apiUrl}/${eventId}/cast/messages/delete/${messageId}`,
    authHeaders()
  );

  return response.data;
};